module.exports = __webpack_public_path__ + "media/images/hmar_logo-5d44fcd813a7112500327c2d99450c37.png";